import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Mail, Instagram, Youtube, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{ backgroundColor: 'var(--text-main)', color: 'white' }}>
      <div className="container mx-auto py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/petsmart-logo.png"
                alt="Petsmart Puppies"
                className="h-12 w-12 rounded-full object-cover"
                loading="lazy"
              />
              <div>
                <h3 className="text-lg font-bold">Petsmart Puppies</h3>
                <div className="flex items-center gap-1 text-yellow-400 text-sm">
                  <span>⭐</span>
                  <span className="font-semibold">4.6</span>
                  <span className="text-gray-400 ml-1">(199 reviews)</span>
                </div>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Your trusted destination for healthy puppies, dog food, and pet accessories in Noida.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/puppies/" className="text-gray-400 hover:text-white transition-colors">
                  Available Puppies
                </Link>
              </li>
              <li>
                <Link to="/supplies/" className="text-gray-400 hover:text-white transition-colors">
                  Pet Supplies
                </Link>
              </li>
              <li>
                <Link to="/care/" className="text-gray-400 hover:text-white transition-colors">
                  Pet Care Guide
                </Link>
              </li>
              <li>
                <Link to="/blog/" className="text-gray-400 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/reviews/" className="text-gray-400 hover:text-white transition-colors">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/contact/" className="text-gray-400 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy/" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms/" className="text-gray-400 hover:text-white transition-colors">
                  Terms of Use
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <MapPin size={18} className="mt-1 flex-shrink-0" style={{ color: 'var(--primary-main)' }} />
                <span>
                  Shop No:- D1 Ground Floor, Near DR Bhimrao Ambedkar Hospital, Sector 31, Noida
                </span>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Phone size={18} style={{ color: 'var(--primary-main)' }} />
                <a href="tel:+917217648679" className="hover:text-white transition-colors">
                  +91 7217648679
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Clock size={18} style={{ color: 'var(--primary-main)' }} />
                <span>Open Daily • Closes 10 PM</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-bold mb-4">Follow Us</h3>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/petshopnoida/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 rounded-full transition-all hover:scale-110"
                style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.youtube.com/@petsmartpetshop"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 rounded-full transition-all hover:scale-110"
                style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
              <a
                href="https://www.facebook.com/share/1C5p2xwiCX/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 rounded-full transition-all hover:scale-110"
                style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400 text-sm">
          <p>© 2026 Petsmart Puppies. All rights reserved. | Trusted Pet Store in Noida</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
